export default __webpack_public_path__ + "static/media/explore-1.6944c57f.jpg";